import { render, staticRenderFns } from "./rM2oImage.vue?vue&type=template&id=c98a48e8&"
import script from "./rM2oImage.vue?vue&type=script&lang=js&"
export * from "./rM2oImage.vue?vue&type=script&lang=js&"
import style0 from "./rM2oImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports